import { TableUIProvider } from "../../../contexts/TableUIContext";
import Promocodes from "./Promocodes";

export default function PromocodesWrapper() {
    return (
        <TableUIProvider>
            <Promocodes />
        </TableUIProvider>
    );
}
